var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectDebitPaymentCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M36 0c19.882 0 36 16.118 36 36a35.836 35.836 0 01-4.826 18.017 10 10 0 00-18.411.155 9.994 9.994 0 005.256 13.001A35.82 35.82 0 0136 72C16.118 72 0 55.882 0 36S16.118 0 36 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M64 36.001c-.001 13.569-9.731 25.185-23.09 27.562-13.36 2.379-26.502-5.165-31.185-17.899-4.685-12.735.437-26.996 12.154-33.84 11.717-6.844 26.654-4.302 35.447 6.032m-8.024 1.124l8.068-1.164-.176-7.652M35.889 18.66v4.375m6.55 4.854s.01-4.854-6.27-4.854c-6.422 0-6.404 6.247-6.404 6.247s-.018 6.441 6.342 6.441c6.36 0 6.344 6.438 6.344 6.438s.018 6.247-6.404 6.247c-6.28 0-6.269-4.852-6.269-4.852m6.111 4.852v4.375",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.999 54l8 8m0-8l-8 8M68 57.999a9.997 9.997 0 01-6.174 9.239 9.997 9.997 0 01-13.063-13.066A9.996 9.996 0 0158 48c5.524.001 10 4.477 10 9.999z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDebitPaymentCancel);
export default __webpack_public_path__ + "static/media/direct-debit-payment-cancel.6c5da904.svg";
export { ForwardRef as ReactComponent };